import DailyEmail from './DailyEmail'

export default DailyEmail
